import { Input } from '@/components/Input';
import { selectPreviousAcn } from '@/context/borrower';
import { useAppSelector } from '@/context/storeHooks';

export interface IProps {
    baseId: string;
    showErrors: boolean;
}

export const testId = 'PreviousAcn';

export function PreviousAcn({ baseId, showErrors }: IProps): JSX.Element {
    // ***** Redux *****
    const currentState = useAppSelector(selectPreviousAcn);

    // ***** Event Handlers *****
    function handleChange(): void {
        return;
    }

    // ***** Render *****
    return (
        <div data-testid={testId} className='w-full'>
            <Input
                title='ACN'
                placeholder='123 456 789'
                showErrors={showErrors && !currentState}
                onChange={handleChange}
                id={`${baseId}-input-acn`}
                value={currentState?.toLocaleString() ?? ''}
                disabled
            />
        </div>
    );
}
